import CardAnswerIndicator from 'components/card/card_answer_indicator';
import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import ConjugationTable from 'components/conjugation_table';
import StickerReaction from 'components/sticker_reaction';
import { DeckUI, OverlayUI } from '@seedlang/state';
import { last , capitalize } from 'lodash';
import { isPresent, isBlank, displayTargetTextCorrectedForLanguage } from '@seedlang/utils';
import VideoPlayerWithSupplement from 'components/media/video_player_with_supplement';
import { Theme } from '@seedlang/constants';
import { ConjugationCardRevealedWrapper } from '@seedlang/hoc';
import { BigSmileFaceIcon, NeutralFaceIcon } from '@seedlang/icons';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const AnswerBanner = styled.div`
  margin-top: 12px;
  width: 100%;
`;

const SentenceWrapper = styled.div`
  margin: ${props => props.margin};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
`;

const TargetAndSource = styled.div`
  margin-bottom: 20px;
  font-style: italic;
  cursor: pointer;
`;

const Source = styled.div`
  margin: 10px 0 20px 0;
  font-style: italic;
  cursor: pointer;
`;

const Feedback = styled.div`
  background: ${props => props.background};
  width: 100%;
  padding: 10px 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  svg {
    width: 20px;
    height: 20px;
    fill: #FFF;
    position: absolute;
    top: 10px;
    left: 10px;
  }
`;

const ConjugationTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
`;

@observer
class ConjugationCardRevealed extends React.Component {
  openSourceEdit = () => {
    DeckUI.createEvent('deck - click translations icon', {
      language_id: this.props.card?.languageId || DeckUI.deck?.languageId,
      card_type_id: this.props.card?.cardType?.id || this.props.card?.cardTypeId,
    });
    OverlayUI.addOverlay('sourceEdit');
  }

  render() {
    return (
      <Wrapper>
        <Feedback
          background={this.props.userCard.correct ? Theme.green : Theme.red}
        >
          {
            this.props.userCard.correct &&
              <BigSmileFaceIcon />
          }
          {
            !this.props.userCard.correct &&
              <NeutralFaceIcon />
          }
          {
            this.props.cardState.revealed && this.props.showVideo &&
              <VideoPlayerWithSupplement
                hasVideoClip
                autoPlay
                width={Math.floor(DeckUI.layout.deckWidth / 4.5)}
                videoClip={this.props.videoClip}
                afterVideoPlayback={this.props.afterVideoPlayback}
              />
          }
          {
            this.props.cardState.revealed && !this.props.showVideo &&
              <StickerReaction
                card={this.props.card}
                reaction={this.props.userCard.correct ? 'happy' : 'disappointed'}
              />
          }

        </Feedback>
        {this.props.revealedText &&
          <AnswerBanner>
            <CardAnswerIndicator text={this.props.revealedText} />
          </AnswerBanner>
        }
        {
          isPresent(this.props.card.sentence) &&
            <SentenceWrapper
              margin={this.props.revealedText ? '4px 0 0' : '20px 0 0'}
            >
              {displayTargetTextCorrectedForLanguage(capitalize(this.props.card.sentence.targetText), this.props.card.sentence.languageId)}
            </SentenceWrapper>
        }
        {
          isBlank(this.props.card.sentence) &&
            <SentenceWrapper
              margin={this.props.revealedText ? '4px 0 10px' : '20px 0 10px'}
            >
              <span>{this.props.personalPronoun}</span>
              <span style={{marginLeft: last(this.props.personalPronoun) === '\'' ? '0px' : '5px', textDecoration: 'underline'}}>{displayTargetTextCorrectedForLanguage(this.props.correctAnswer, this.props.card.languageId)}</span>
            </SentenceWrapper>
        }
       {
         isPresent(this.props.card.sentence) &&
            <Source>
              <span
                onClick={this.openSourceEdit}
              >
                {this.props.card.sentence.sourceText}
              </span>
            </Source>
       }
       {
          isBlank(this.props.card.sentence) &&
            <TargetAndSource
              onClick={this.openSourceEdit}
            >
              {this.props.card.word.targetText} -  {this.props.source}
            </TargetAndSource>
       }
        <ConjugationTableWrapper>
         <ConjugationTable
           inDeck
           hideHeader
           highlightPronoun={this.props.card.pronoun}
           padding='0'
           word={this.props.card.word}
           conceptId={this.props.tenseConceptId}
         />
       </ConjugationTableWrapper>
      </Wrapper>
    );
  }
}

export default ConjugationCardRevealedWrapper(ConjugationCardRevealed);
